import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonDataService } from '../../common-data.service';

@Component({
  selector: 'app-roster-members-table',
  templateUrl: './roster-members-table.component.html',
  styleUrls: ['./roster-members-table.component.scss']
})
export class RosterMembersTableComponent {

  // Data inputs
  @Input() rosterName: string;
  @Input() totalMembers: number;
  @Input() teamsData: any;
  @Input() filterData: any = '';
  @Input() filterRoster: string;
  @Input() searchby: string = 'search';
  @Input() selectAll: boolean = false;
  @Input() loading: boolean = false;
  @Input() rosterSearch: boolean = false;
  @Input() memNotFound: boolean = false;
  @Input() sortType: string = 'desc';
  @Input() queryType: string = 'first_name_order';
  @Input() currentPg: number = 1;
  @Input() roasterdefaultCounter: number = 20;
  @Input() defaultShowingMembers: number = 5;
  @Input() isDemoRoster: boolean = false;
  @Input() indivTeamsFirstName: string;
  @Input() indivTeamsLastName: string;

  // Outputs
  @Output() rosterAddMember = new EventEmitter<void>();
  @Output() accordToggle = new EventEmitter<{ className: string; event: MouseEvent }>();
  @Output() searchRoaster = new EventEmitter<{ value: string; showHide: boolean; clear?: boolean }>();
  @Output() filterRosterChange = new EventEmitter<string>();
  @Output() updateFilter = new EventEmitter<any>();
  @Output() additionalTeamPopup = new EventEmitter<{ memberDetails: any; invitePop: boolean }>();
  @Output() selectAllChange = new EventEmitter<boolean>();
  @Output() selectAllRoaster = new EventEmitter<boolean>();
  @Output() sortRoaster = new EventEmitter<{ sortType: string; queryType: string }>();
  @Output() memberChecked = new EventEmitter<any>();
  @Output() editRosterMem = new EventEmitter<any>();
  @Output() removeRosterMem = new EventEmitter<{ record: any; oneOrMulti: number }>();
  @Output() roasterMembers = new EventEmitter<{ count: number; page: number }>();
  @Output() rosterMemberProfile = new EventEmitter<any>();
  @Output() roasterdefaultCounterChange = new EventEmitter<number>();

  constructor(public CommonDataService: CommonDataService) {}

  secretEmail(usrEmail: string, length = 8): string {
    return usrEmail?.substring(0, length) + '...';
  }

  pageCounter(i: number): any[] {
    let totalPg: any = i / this.roasterdefaultCounter;
    if (i % this.roasterdefaultCounter !== 0) {
      totalPg = totalPg + 1;
      totalPg = parseInt(totalPg);
    }
    return new Array(totalPg);
  }

  onAccordToggle(className: string, event: MouseEvent): void {
    this.accordToggle.emit({ className, event });
  }

  onSearchRoaster(value: string, showHide: boolean, clear: boolean = false): void {
    this.searchRoaster.emit({ value, showHide, clear });
  }

  onFilterRosterChange(value: string): void {
    this.filterRoster = value;
    this.filterRosterChange.emit(value);
  }

  onClearSearch(): void {
    this.filterRosterChange.emit('');
    this.searchRoaster.emit({ value: '', showHide: true, clear: true });
  }

  onUpdateFilter(event: any): void {
    this.updateFilter.emit(event);
  }

  onAdditionalTeamPopup(memberDetails: any, invitePop: boolean = false): void {
    this.additionalTeamPopup.emit({ memberDetails, invitePop });
  }

  onSelectAllChange(checked: boolean): void {
    this.selectAllChange.emit(checked);
    this.selectAllRoaster.emit(checked);
  }

  onSortRoaster(sortType: string, queryType: string): void {
    this.sortRoaster.emit({ sortType, queryType });
  }

  onMemberChecked(record: any): void {
    this.memberChecked.emit(record);
  }

  onEditRosterMem(record: any): void {
    this.editRosterMem.emit(record);
  }

  onRemoveRosterMem(record: any, oneOrMulti: number): void {
    this.removeRosterMem.emit({ record, oneOrMulti });
  }

  onRoasterMembers(count: number, page: number): void {
    this.roasterMembers.emit({ count, page });
  }

  onRoasterdefaultCounterChange(): void {
    this.roasterdefaultCounterChange.emit(this.roasterdefaultCounter);
    this.roasterMembers.emit({ count: this.roasterdefaultCounter, page: 1 });
  }

  onRosterMemberProfile(profile: any): void {
    this.rosterMemberProfile.emit(profile);
  }

  onAddMembers(): void {
    this.rosterAddMember.emit();
  }
}
